<div id="personal-calculation" class="flex flex-col flex-grow" data-cy="personal-calculation">
  <div class="form mb-24 container mx-auto">
    <ife-title
      [title]="'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.title' | translate"
      [subtitle]="'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.description' | translate"
      data-cy="personal-calculation-title"
    ></ife-title>

    <!-- Info box / Price box -->
    <div class="infoBox" data-cy="info-box">
      <div class="infoBox__image relative w-64 h-72">
        <img class="absolute" [src]="'./assets/evc/img/chargerAccess.png'" alt="Charging station" />
      </div>

      <!-- Price -->
      <div class="infoBox__price">
        <p>
          {{
            'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.infoBox.priceIndication'
              | translate
          }}
        </p>
        <p class="price-text">{{ simulation.discountedPrice | number : '' : 'fr-BE' }} &euro;</p>
        <p class="price-vat">
          {{ 'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.infoBox.vat' | translate }}
        </p>
      </div>
      <!-- Info items -->
      <ul class="infoBox__list">
        <li>
          {{
            'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.infoBox.checkMark1' | translate
          }}
        </li>
        <li>
          {{
            'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.infoBox.checkMark2' | translate
          }}
        </li>
        <li>
          {{
            'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.infoBox.checkMark3' | translate
          }}
        </li>
      </ul>
    </div>

    <!-- Navigation buttons -->
    <div class="w-full flex justify-center">
      <a
        [href]="getQuoteUrl()"
        [analyticsEvent]="'ifeSimulator:click:get-real-quote'"
        data-cy="get-quote"
        class="btn-primary btn mx-auto text-center"
      >
        {{ 'modules.evSimulator.steps.personalCalculation.fields.personalCalculation.ctaButton' | translate }}
      </a>
    </div>
  </div>

  <!-- Extra page info -->
  <div class="bg-white px-8 pb-16 pt-24 flex-grow w-full">
    <ife-title
      [title]="'modules.evSimulator.steps.personalCalculation.flow.title' | translate"
      data-cy="flow-title"
    ></ife-title>

    <swiper-container
      id="swiper"
      class="flow-steps flex m-auto"
      data-cy="swiper"
      appSwiper
      #swiper
      [config]="swiperConfig"
      init="false"
    >
      <swiper-slide class="flow-steps--step" *ngFor="let index of slidesIterator">
        <div class="flow-steps--step-image">
          <img
            [src]="'./assets/evc/img/flow-' + index + '.png'"
            [alt]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.title' | translate"
          />
          <span>{{ index }}</span>
        </div>
        <span
          class="flow-steps--step-title"
          [innerHTML]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.title' | translate"
        ></span>
        <span
          [innerHTML]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.description' | translate"
        ></span>
        <div *ngIf="index !== 4" class="flow-steps--line"></div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>
